// Utils
import moment from "moment";
import { formatDatetime } from "react-lib/utils/dateUtils";
import { HeaderLogoWithPublishDetail } from "react-lib/apps/HISV3/common/HeaderPdfFormTemplate";
import { TDocumentDefinitions } from "pdfmake/interfaces";

const FORM_NAME = `FormAnesSatisfactionStatReport`;

const FormAnesSatisfactionStatReport = async (props: any): Promise<TDocumentDefinitions> => {
  // console.log("Yeti Anes Satisfaction Props: ", props);

  const currentDate = moment();

  const headerForm = await HeaderLogoWithPublishDetail({
    form: FORM_NAME,
    font: "THSarabunNew",
    logoHeight: 30,
    isHospitalVertical: true,
    haveBorder: true,
    pageMargins: [10, 85, 10, 10],
    headerMargins: [10, 10, 10, 0],
    titleContent: [
      {
        text: `จำนวนผู้รับบริการระงับความรู้สึก แบ่งตามระดับความพึงพอใจ`,
        alignment: "center",
        fontSize: 15,
        bold: true,
      },
      {
        text: `วิธีระงับความรู้สึก ${props.params?.anesthesia_label || "ทั้งหมด"}`,
        alignment: "center",
        fontSize: 15,
      },
      {
        text: `วันที่ดมยา ${props.params?.startDate || " "} - ${props.params?.endDate || " "}`,
        alignment: "center",
        fontSize: 15,
      },
    ],
    publishContent: [
      {
        text: [
          { text: "ผู้พิมพ์: ", bold: true, preserveLeadingSpaces: true },
          { text: props.params?.print_user || " " },
        ],
        alignment: "right",
        fontSize: 12,
      },
      {
        text: [
          { text: "วันที่พิมพ์: ", bold: true, preserveLeadingSpaces: true },
          { text: formatDatetime(currentDate, true) },
        ],
        alignment: "right",
        fontSize: 12,
      },
    ],
  });

  const { font, images, styles } = headerForm;

  const generateTableBody = (data: any, columns: string[]) => {
    let body: any = [];

    // Header of Table
    body.push([
      { text: "วิธีระงับความรู้สึก", bold: true, alignment: "center" },
      { text: "ระดับ 1", bold: true, alignment: "center" },
      { text: "ระดับ 2", bold: true, alignment: "center" },
      { text: "ระดับ 3", bold: true, alignment: "center" },
      { text: "ระดับ 4", bold: true, alignment: "center" },
      { text: "ระดับ 5", bold: true, alignment: "center" },
      { text: "ประเมินไม่ได้", bold: true, alignment: "center" },
      { text: "ไม่ได้เยี่ยม", bold: true, alignment: "center" },
      { text: "รวม", bold: true, alignment: "center" },
    ]);

    if (Object.keys(props).length > 0) {
      const fieldsData = data?.items.map((item: any) => {
        const satisfactionTotal = item.satisfaction_count.reduce(
          (acc: number, cur: number) => acc + cur,
          0
        );
        return { ...item, ...item.satisfactionCount, satisfactionTotal: satisfactionTotal };
      });

      const summaryData = data?.summaryTotals?.satisfaction;

      summaryData.satisfaction_level.forEach((level: string, index: number) => {
        summaryData[level] = summaryData.satisfaction_count[index];
      });

      summaryData.summaryTotal = summaryData?.satisfaction_count.reduce(
        (acc: number, cur: number) => acc + cur,
        0
      );

      fieldsData.forEach((row: any) => {
        let dataRow: any = [];

        columns.forEach((column: any) => {
          switch (column) {
            case "anesthesia_name":
              dataRow.push({ text: row[column], bold: true });
              break;
            default:
              dataRow.push({ text: row[column].toString(), alignment: "center" });
              break;
          }
        });
        body.push(dataRow);
      });

      if (summaryData) {
        // console.log("Yeti Summary Data: ", summaryData);

        body.push([
          {
            text: "จำนวนผู้รับบริการรวม",
            fillColor: "#cccccc",
          },
          {
            text: `${summaryData["ระดับ 1"]}`,
            fillColor: "#cccccc",
            bold: true,
            alignment: "center",
          },
          {
            text: `${summaryData["ระดับ 2"]}`,
            fillColor: "#cccccc",
            bold: true,
            alignment: "center",
          },
          {
            text: `${summaryData["ระดับ 3"]}`,
            fillColor: "#cccccc",
            bold: true,
            alignment: "center",
          },
          {
            text: `${summaryData["ระดับ 4"]}`,
            fillColor: "#cccccc",
            bold: true,
            alignment: "center",
          },
          {
            text: `${summaryData["ระดับ 5"]}`,
            fillColor: "#cccccc",
            bold: true,
            alignment: "center",
          },
          {
            text: `${summaryData["ประเมินไม่ได้"]}`,
            fillColor: "#cccccc",
            bold: true,
            alignment: "center",
          },
          {
            text: `${summaryData["ไม่ได้เยี่ยม"]}`,
            fillColor: "#cccccc",
            bold: true,
            alignment: "center",
          },
          {
            text: `${summaryData.summaryTotal}`,
            fillColor: "#cccccc",
            bold: true,
            alignment: "center",
          },
        ]);
      }
    }

    return body;
  };

  const tableReport = (data: any, columns: string[]) => {
    return {
      table: {
        widths: ["*", "10%", "10%", "10%", "10%", "10%", "10%", "10%", "10%"],
        headerRows: 1,
        body: generateTableBody(data, columns),
      },
    };
  };

  return {
    pageSize: "A4",
    pageOrientation: "landscape",
    defaultStyle: {
      font: font,
      lineHeight: 1,
      fontSize: 16, // default
    },
    ...headerForm,
    styles: { ...styles },
    images: { ...images },
    content: [
      tableReport(props || {}, [
        "anesthesia_name",
        "ระดับ 1",
        "ระดับ 2",
        "ระดับ 3",
        "ระดับ 4",
        "ระดับ 5",
        "ประเมินไม่ได้",
        "ไม่ได้เยี่ยม",
        "satisfactionTotal",
      ]),
    ],
  };
};

export default FormAnesSatisfactionStatReport;
